<template>
    <div class="mt-4">
        <app-header></app-header>
            <!-- 截取头像的遮罩层 -->
            <div id="img-upload">
                <div class="img-container" v-show="panel">
                    <img id="image" :src="panelImageUrl" alt="Picture">
                    <v-btn id="img-button-cancel" class="primary" dark @click="cancelPanel">{{$t("common.cancel")}}</v-btn>
                    <v-btn id="img-button-submit" class="primary" dark @click="cropperImage">{{$t("common.apply")}}</v-btn>
                </div>
            </div>
            <div v-on:click="hideBlock">
                <v-layout row wrap>
                    <v-flex xs12 md12 lg12 sm12 class="col-height-auto"> 
                       <div class="profile-head">
                        <div class="profile-top" :style="{backgroundImage: 'url('+userDetail.coverImage+')'}">
                            <!-- 上传封面图片 -->
                            <Upload ref="upload" name="coverImage"
                                :max-size="1024"
                                :format="['jpg','jpeg','png']"
                                :action="uploadCoverImageUrl"
                                :headers="headers"
                                :with-credentials=true
                                :show-upload-list=false
                                :before-upload="uploadCoverImageBefore"
                                >
                                <div>
                                    <v-btn small flat dark class="mt-4 mr-4 right" style="position:absolute;right:0px;">{{$t("userSetting.changeCoverImage")}}</v-btn>
                                </div>
                            </Upload>
                        </div>
                        <div class="profile-bottom">
                            <div class="picture">
                                <div class="user-image text-xs-center mb-3">
                                    <!-- 上传用户头像 -->
                                    <Upload
                                        ref="upload"
                                        name="upfile"
                                        :max-size="1024"
                                        :format="['jpg','jpeg','png']"
                                        :action="uploadUrl"
                                        :headers="headers"
                                        :with-credentials=true
                                        :before-upload="beforeUpload"
                                        :show-upload-list=false>
                                            <v-avatar color="primary pointer" size="100" :title="$t('userSetting.uploadImgTitle')">
                                                <img v-show="userDetail.image != null" :src="userDetail.image" :alt="userDetail.userName" />
                                                <span v-show="userDetail.image == null" class="font-50 white--text">
                                                    {{ userDetail.userName != null ? userDetail.userName.trim().substring(0, 1).toLocaleUpperCase() : ''}}
                                                </span>
                                            </v-avatar>
                                            <!-- <img alt="" :title="$t('userSetting.uploadImgTitle')" v-bind:src="userDetail.image" class="img-responsive rounded-circle pointer"> -->
                                    </Upload>
                                </div>
                            </div>
                            <div class="user-list-content mb-5">
                              <div class="text-xs-center">
                                <h3 class="fw-700">{{userDetail.nickName}} ({{userDetail.reputationScore}})</h3>
                                 <div class="font-16 fw-500 mt-3">
                                    <span class="mx-3">
                                      <v-icon small>fas fa-at</v-icon><span class="ml-1">{{userDetail.userName}}</span>
                                    </span>
                                    <span>
                                      <v-icon small>fas fa-calendar-alt</v-icon><span class="ml-1">{{regTimeFormat(userDetail.regTime)}}</span>
                                    </span>
                                  </div>
                            </div>
                    </div>
                </div>
            </div>
            </v-flex>
            </v-layout>

            <v-container grid-list-xl mt-5 mb-5 pb-5 align-center justify-center>
                <v-layout row wrap justify-center>
                    <v-flex xs12 md5 lg3>
                        <div class="inbox-head">
                            <div class="mailbox-items-warp">
                    <div class="app-card">
                    <v-list>
                        <v-list-tile @click="getMenuData('account')" :title="$t('userSetting.account')">
                            <v-list-tile-action>
                              <v-icon>account_box</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.account")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="getMenuData('password')" :title="$t('userSetting.password')">
                            <v-list-tile-action>
                              <v-icon>lock</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.password")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="getMenuData('kyc')" :title="$t('userSetting.kyc.kyc')">
                            <v-list-tile-action>
                              <v-icon>fas fa-id-card</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.kyc.kyc")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="getMenuData('privacyAndSafety')" :title="$t('userSetting.privacyAndSafety')">
                            <v-list-tile-action>
                              <v-icon>security</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.privacyAndSafety")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="getMenuData('googleAuthentication')" :title="$t('userSetting.googleAuthentication')">
                            <v-list-tile-action>
                              <v-icon>phonelink_setup</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.googleAuthentication")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile @click="getMenuData('accountBinding')" :title="$t('userSetting.accountBinding')">
                            <v-list-tile-action>
                              <v-icon>fas fa-globe-europe</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{$t("userSetting.accountBinding")}}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </div>
            </div>
            </div>
            </v-flex>
            <v-flex xs12 md7 lg9 class="inbox-content">
                <div class="inbox-content-wrap">
                    <v-card>
                    <v-container fluid>
                        <!-- - - - - - - - - - - - - - - - - - - - -Account- - - - - - - - - - - - - - -  -->
                        <div v-show="isShowAccount" class="ml-3 mr-3 mb-5">
                            <h2 class="fw-700 mb-3">{{$t("userSetting.account")}}</h2>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.username")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.username')" v-model="userDetail.userName" disabled></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader><span>{{$t("userSetting.nickName")}}</span></v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.nickName')" v-model="userDetail.nickName" :disabled="!isShowNickNameInput"></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('common.edit')" placement="bottom">
                                        <v-icon v-show="!isShowNickNameInput" @click="isShowNickNameInput = !isShowNickNameInput">edit</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.confirm')" placement="bottom">
                                        <v-icon v-show="isShowNickNameInput" @click="updateNickName">fas fa-check</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.cancel')" placement="bottom">
                                        <v-icon class="ml-3" v-show="isShowNickNameInput" @click="showNickNameInput">fas fa-times</v-icon>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.email")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.email')" v-model="userDetail.regEmail" :disabled="!isShowRegEmailInput"></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('common.edit')" placement="bottom">
                                        <v-icon v-show="!isShowRegEmailInput" @click="isShowRegEmailInput = !isShowRegEmailInput">edit</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.confirm')" placement="bottom">
                                        <v-icon v-show="isShowRegEmailInput" @click="sendUpdateRegEmail">fas fa-check</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.cancel')" placement="bottom">
                                        <v-icon class="ml-3" v-show="isShowRegEmailInput" @click="showRegEmailInput">fas fa-times</v-icon>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.invitationCode")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.invitationCode')" v-model="userDetail.invitationCode"disabled class="pointer"></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('userSetting.copyInvitationLink')" placement="bottom">
                                        <span id="invitationLink" :data-clipboard-text="invitationLink">
                                            <v-icon @click="copyInvitationLink">fas fa-copy</v-icon>
                                        </span>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.avatar")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.avatar')" v-model="userDetail.image" :disabled="!isShowImageInput"></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('common.edit')" placement="bottom">
                                        <v-icon v-show="!isShowImageInput" @click="isShowImageInput = !isShowImageInput">edit</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.confirm')" placement="bottom">
                                        <v-icon v-show="isShowImageInput" @click="updateImage">fas fa-check</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.cancel')" placement="bottom">
                                        <v-icon class="ml-3" v-show="isShowImageInput" @click="showImageInput">fas fa-times</v-icon>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.coverImage")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-text-field :label="$t('userSetting.coverImage')" v-model="userDetail.coverImage" :disabled="!isShowCoverImageInput"></v-text-field>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('common.edit')" placement="bottom">
                                        <v-icon v-show="!isShowCoverImageInput" @click="isShowCoverImageInput = !isShowCoverImageInput">edit</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.confirm')" placement="bottom">
                                        <v-icon v-show="isShowCoverImageInput" @click="updateCoverImage">fas fa-check</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.cancel')" placement="bottom">
                                        <v-icon class="ml-3" v-show="isShowCoverImageInput" @click="showCoverImageInput">fas fa-times</v-icon>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                            <v-layout row align-center>
                              <v-flex xs3>
                                <v-subheader>{{$t("userSetting.timeZone")}}</v-subheader>
                              </v-flex>
                              <v-flex xs6>
                                <v-select v-model="userDetail.timeZoneId" :items="timeZoneList" item-text="name" item-value="timeZoneId" :label="$t('userSetting.timeZone')" @input="updateTimeZone" :disabled="!isShowTimeZoneInput"></v-select>
                              </v-flex>
                              <v-flex xs3>
                                <div>
                                    <Tooltip :content="$t('common.edit')" placement="bottom">
                                        <v-icon v-show="!isShowTimeZoneInput" @click="isShowTimeZoneInput = !isShowTimeZoneInput">edit</v-icon>
                                    </Tooltip>
                                    <Tooltip :content="$t('common.confirm')" placement="bottom">
                                        <v-icon v-show="isShowTimeZoneInput" @click="isShowTimeZoneInput = !isShowTimeZoneInput">fas fa-check</v-icon>
                                    </Tooltip>
                                </div>
                              </v-flex>
                            </v-layout>
                        </div>
                        <!-- - - - - - - - - - - - - - - - - - - - -Password- - - - - - - - - - - - - - -  -->
                        <div v-show="isShowPassword" class="ml-3 mr-3">
                            <h2 class="fw-700 mb-5">{{$t("userSetting.password")}}</h2>
                            <v-layout wrap row align-center>
                              <v-flex xs12>
                                <span class="font-14 fw-500">{{$t("userSetting.passwordMsg")}}</span>
                              </v-flex>
                              <v-flex xs12>
                                <v-form ref="formPassword" v-model="formPasswordValid" lazy-validation>
                                    <v-text-field type="password" v-model="formPassword.passWord" :rules="currentPasswordRules" :label="$t('userSetting.currentPassword')" required></v-text-field>
                                    <span @click="goPassword" class="pointer font-12">
                                    {{$t("userSetting.forgotPassword")}}?</span>
                                    <v-text-field type="password" v-model="formPassword.newPassWord" :rules="newPasswordRules" :label="$t('userSetting.newPassword')" required></v-text-field>
                                    <v-text-field type="password" v-model="formPassword.confirmNewPassWord" :rules="confirmNewPasswordRules" :label="$t('userSetting.verifyPassword')" required></v-text-field>
                                    <v-btn color="primary" class="mt-3" outline small @click="updatePassword">{{$t("userSetting.saveChanges")}}</v-btn>
                                </v-form>
                              </v-flex>
                            </v-layout>
                        </div>
                        <!-- - - -  - - - - - - - -KYC- - - - - - - - - - - - - - - - -  -->
                        <div v-show="isShowKyc" class="ml-3 mr-3">
                            <h2 class="fw-bold mb-5">{{$t("userSetting.kyc.kyc")}}</h2>
                            <div v-show="userDetail.realNameAuthentication == '-1'">
                                <v-layout wrap row align-center>
                                  <v-flex xs7>
                                    <span>{{$t("userSetting.kyc.beginMsg")}}</span>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-btn color="primary" outline small @click="gotoKyc">
                                            {{$t("userSetting.kyc.begin")}}
                                        </v-btn>
                                  </v-flex>
                              </v-layout>
                            </div>
                            <div v-show="userDetail.realNameAuthentication == '-2'">
                                <v-layout wrap row align-center>
                                  <v-flex xs7>
                                    <span>{{$t("userSetting.kyc.underReviewMsg")}}</span>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-btn color="primary" outline small disabled>
                                        {{$t("userSetting.kyc.underReview")}}
                                    </v-btn>
                                  </v-flex>
                              </v-layout>
                            </div>
                            <div v-show="userDetail.realNameAuthentication == '1'">
                                <v-layout wrap row align-center>
                                  <v-flex xs7>
                                    <span>{{$t("userSetting.kyc.rejectedMsg")}}</span>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-btn color="primary" outline small @click="gotoKyc">
                                        {{$t("userSetting.kyc.rejected")}}
                                    </v-btn>
                                  </v-flex>
                              </v-layout>
                            </div>
                            <div v-show="userDetail.realNameAuthentication == '0'">
                                <v-layout wrap row align-center>
                                  <v-flex xs7>
                                    <span>{{$t("userSetting.kyc.passedMsg")}}</span>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-btn color="primary" outline small disabled>
                                        {{$t("userSetting.kyc.passed")}}
                                    </v-btn>
                                  </v-flex>
                              </v-layout>
                            </div>
                        </div>
                        <!-- - - -  - - - - - - - -PrivacyAndSafety- - - - - - - - - - - - - - - - - - - - -->
                        <div v-show="isShowPrivacyAndSafety" class="ml-3 mr-3">
                            <h2 class="fw-bold mb-5">{{$t("userSetting.privacyAndSafety")}}</h2>
                            <v-layout row wrap>
                                <v-flex xs12 md12 lg12>
                                    <div class="font-md">
                                        <li>{{$t("userSetting.emailNotifications")}}</li>
                                    </div>
                                    <div class="ml-4">
                                        <v-checkbox v-model="userRight.isReceiveAuthEmail" color="primary" readonly :label="$t('userSetting.receiveAuthEmail')"></v-checkbox>
                                        {{$t("userSetting.receiveAuthEmailHint")}}
                                        <v-checkbox v-model="userRight.isReceivePushEmail" color="primary" :label="$t('userSetting.receivePushEmail')"></v-checkbox>
                                        {{$t("userSetting.receivePushEmailHint")}}
                                    </div>
                                    <div class="font-md mt-3">
                                        <li>{{$t("userSetting.dataProtections")}}</li>
                                    </div>
                                    <div class="ml-4">
                                        <v-checkbox v-model="userRight.isHideSipToken" color="primary" :label="$t('userSetting.hideSipToken')"></v-checkbox>
                                        {{$t("userSetting.hideSipTokenHint")}}
                                    </div>
                                </v-flex>
                                <v-flex xs12 md12 lg12>
                                    <div v-show="!userDetail.openAuthentication">
                                        <v-btn color="primary" class="mt-3" outline small :disabled="userRightVaild" @click="updateUserRight">{{$t("userSetting.saveChanges")}}</v-btn>
                                        </div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <!-- - - -  - - - - - - - -GoogleAuthentication- - - - - - - - - - - - - - - - -  -->
                        <div v-show="isShowGoogleAuthentication" class="ml-3 mr-3">
                            <h2 class="fw-bold mb-5">{{$t("userSetting.googleAuthentication")}}</h2>
                            <v-layout row wrap>
                                <v-flex xs7>
                                    <div v-show="userDetail.openAuthentication">
                                        <span>{{$t("userSetting.enabledMsg")}}</span>
                                    </div>
                                    <div v-show="!userDetail.openAuthentication">
                                        <span>{{$t("userSetting.disabledMsg")}}</span>
                                    </div>
                                </v-flex>
                                <v-flex xs5>
                                    <div v-show="userDetail.openAuthentication">
                                        <v-btn color="primary" outline small  @click="showDisableModal">{{$t("userSetting.disable")}}</v-btn>
                                    </div>
                                    <div v-show="!userDetail.openAuthentication">
                                        <v-btn color="primary" outline small  @click="gotoAuthentication" :loading="enableLoading">{{$t("userSetting.enable")}}</v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                        <!-- - - -  - - - - - - - -Account Binding- - - - - - - - - - - - - - - - -  -->
                        <div v-show="isShowAccountBinding" class="ml-3 mr-3">
                           <h2 class="fw-bold mb-5">{{$t("userSetting.accountBinding")}}</h2>
                           <v-layout row wrap class="font-md">
                                <div class="small-12 ml-3">
                                    {{$t("userSetting.viewOrCopyHint")}}
                                </div>
                                <div class="small-12 mt-5 ml-3">
                                    <v-icon color="primary">fas fa-key</v-icon>
                                    <span class="ml-2 mr-5">{{$t("userSetting.token")}}:</span>
                                    <span v-show="userRight.isHideSipToken">
                                        {{userDetail.sipToken}}
                                    </span>
                                    <span v-show="!userRight.isHideSipToken">
                                        <Tooltip :content="$t('userSetting.clickToCopy')" placement="bottom">
                                            <span id="sipToken" class="pointer" :data-clipboard-text="userDetail.sipToken" @click="copySipToken">
                                                {{userDetail.sipToken}}
                                            </span>
                                        </Tooltip>
                                    </span>
                                    <v-icon color="primary pointer" :title="$t('userSetting.refresh')" @click="updateSipToken">refresh</v-icon>
                                    <br>
                                </div>
                            </v-layout>
                        </div>
                      </v-container>
                      </v-card>

                        <!-- 禁用认证的模态框 -->
                        <div style="background-color: red;">
                            <Modal v-model="isShowDisableModal" align="center">
                                <p slot="header" style="font-family: Helvetica-Bold; color:#333333;font-size:20px;letter-spacing: 0;line-height: 30px;height: 40px;">{{$t("userSetting.disableModalTitle")}}</p>
                                <label style="font-size: 14px;">{{$t("userSetting.disableModalMsg")}}</label>
                                <v-form ref="formDisableAuthentication" class="mt-5 mb-4">
                                    <v-flex xs6 md4 lg3>
                                        <v-text-field id="enter-verify-code" v-model="formDisableAuthentication.randomCode" :counter="6" :rules="randomCodeRules" single-line outline></v-text-field>
                                    </v-flex>
                                    <v-text-field v-show="false" v-model="formDisableAuthentication.id" disabled required></v-text-field>
                                    <v-text-field v-show="false" v-model="formDisableAuthentication.authenticationSecret" disabled required></v-text-field>
                                </v-form>
                                <label style="font-size: 14px;">{{$t("userSetting.disableModalContact")}}</label>
                                <div slot="footer" align="center">
                                    <v-btn class="primary" dark small  @click="disableModalCancel">{{$t("common.cancel")}}</v-btn>
                                    <v-btn class="primary" dark small  @click="verityRandomCode('formDisableAuthentication')">{{$t("common.verify")}}</v-btn>
                                </div>
                            </Modal>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
    </div>
</template>
<style>
    @import '../../../static/css/custom/img-upload.css';
</style>
<script>
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    import config from '../../config.js'
    import Clipboard from 'clipboard'
    import Cropper from 'cropperjs'
    import Md5 from 'js-md5'
    import {eventBus} from '../../assets/js/eventBus.js'
    export default {
        data(){
            const passWord = (rule, value, callback) => {
                let passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
                if (value == 0) {
                    callback(new Error(this.$t("userSetting.errorCallback.passWord.empty")));
                } else {
                    callback();
                }
            };
            const newPassWord = (rule, value, callback) => {
                let passreg = /^.*(?=.{8,})(?=.*\d)(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*? ]).*$/;
                if (value == 0) {
                    callback(new Error(this.$t("userSetting.errorCallback.newPassWord.empty")));
                } else if (!passreg.test(value)) {
                    callback(new Error(this.$t("userSetting.errorCallback.newPassWord.value")));
                } else {
                    callback();
                }
            };
            const confirmNewPassWord = (rule, value, callback) => {
                if (value == 0) {
                    callback(new Error(this.$t("userSetting.errorCallback.confirmNewPassWord.again")));
                }else if (value !== this.formPassword.newPassWord) {
                    callback(new Error(this.$t("userSetting.errorCallback.confirmNewPassWord.match")));
                } else {
                    callback();
                }
            };
            const validateId = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t("userSetting.errorCallback.id")));
                } else {
                    callback();
                }
            };
            const validateAuthenticationSecret = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error(this.$t("userSetting.errorCallback.secret")));
                } else {
                    callback();
                }
            };
            const validateRandomCode = (rule, value, callback) => {
                if (!value) {
                    callback(new Error(this.$t("userSetting.errorCallback.code.empty")));
                } else if (!Number.isInteger(+value)) {
                    callback(new Error(this.$t("userSetting.errorCallback.code.value")));
                } else if((value+'').length !== 6) {
                    callback(new Error(this.$t("userSetting.errorCallback.code.digits")));
                } else {
                    callback();
                }
            };
            const validateImage = (rule, value, callback) => {
                if(value === ''){
                    callback(new Error(this.$t("userSetting.errorCallback.image.empty")));
                } else if(value.substring(0, 7) === 'http://'){
                    callback();
                } else if(value.substring(0, 8) === 'https://'){
                    callback();
                } else {
                    callback(new Error(this.$t("userSetting.errorCallback.image.invalid")));
                }
            };
            const validateCoverImage = (rule, value, callback) => {
                if(value === ''){
                    callback(new Error(this.$t("userSetting.errorCallback.image.empty")));
                } else if(value.substring(0, 7) === 'http://'){
                    callback();
                } else if(value.substring(0, 8) === 'https://'){
                    callback();
                } else {
                    callback(new Error(this.$t("userSetting.errorCallback.image.invalid")));
                }
            };
            return{
                image_url:'',
                username: this.$store.state.user.name,  // 用户名
                uploadUrl: '',                          // 上传头像
                uploadCoverImageUrl: '',                //上传封面图片
                headers: {//设置请求头
                    'Authorization': 'Bearer '+ localStorage.getItem('token')
                },
                headerImage:'',
                picValue:'',
                cropper:'',
                croppable:false,                        // 裁剪的对象
                panel:false,                            // 上传图片时的面板
                panelImageUrl: '',                      // 面板的图片
                //支持发送 cookie 凭证信息
                credentials: true,
                isShowNickName: true,
                isShowNickNameInput: false,             // 是否显示修改昵称的输入框
                isShowRegEmailInput: false,             // 是否显示修改邮箱的输入框
                isShowImageInput: false,                // 是否显示修改图片的输入框
                isShowCoverImageInput: false,           // 是否显示修改封面的输入框
                isShowTimeZoneInput: false,             // 是否显示修改时区的选择框
                isShowAccount: true,                    // 是否显示账户div
                isShowPassword: false,                  // 是否显示密码div
                isShowKyc: false,                       // 是否显示KYC div
                isShowPrivacyAndSafety: false,          // 是否显示隐私div
                isShowGoogleAuthentication: false,      // 是否显示谷歌div
                isShowAccountBinding: false,            // 是否显示账户绑定div
                isShowConfirmWalletModal: false,        // 是否显示确认钱包的模态框
                isShowDisableModal: false,              // 是否显示禁用2-FA的模态框
                enableLoading: false,                   // 启用认证的加载中
                invitationLink: config.ip + '#/register?invitationCode=' + localStorage.getItem("invitationCode"),
                userDetail: {},                         // 用户详情对象
                level: {},
                formNickName: {nickName: ''},
                formRegEmail: {
                    id: '',
                    regEmail: '',
                },
                formImage: {
                    userId: '',
                    image: '',
                },
                formCoverImage: {
                    userId: '',
                    coverImage: '',
                },
                formPasswordValid: false,
                formPassword: {
                    id:'',
                    passWord: '',
                    newPassWord: '',
                    confirmNewPassWord: '',
                },
                formAuthentication: {
                    id: '',
                },
                formDisableAuthentication: {
                    id: '',
                    authenticationSecret: '',
                    randomCode: '',
                },
                ruleRegEmail: {
                    regEmail: [
                        { required: true, message: this.$t("userSetting.requiredMessage.regEmailBeEmpty"), trigger: 'change'},
                        { type: 'email', message: this.$t("userSetting.requiredMessage.regEmailFormat"), trigger: 'change' }
                    ]
                },
                ruleImage: {
                    image: [{required: true, validator: validateImage, trigger: 'blur' }],
                },
                ruleCoverImage: {
                    image: [{required: true, validator: validateCoverImage, trigger: 'blur' }],
                },
                rulePassword: {
                    passWord: [{ validator: passWord, trigger: 'blur' }],
                    newPassWord: [{ validator: newPassWord, trigger: 'blur' }],
                    confirmNewPassWord:[{ validator: confirmNewPassWord, trigger: 'blur' }],
                },
                currentPasswordRules: [
                    v => !!v || this.$t('register.errorCallback.passWord.empty')
                ],
                newPasswordRules: [
                    v => !!v || this.$t('register.errorCallback.passWord.empty'),
                    v => /^(?=.*\d)(?=.*[A-Za-z]).{8,20}$/.test(v) || this.$t('register.errorCallback.passWord.value')
                ],
                confirmNewPasswordRules: [
                    v => !!v || this.$t('register.errorCallback.repassWord.empty'),
                    v => v == this.formPassword.newPassWord || this.$t('register.errorCallback.repassWord.value')
                ],
                ruleDisableAuthentication: {
                    id: [
                        { validator: validateId, trigger: 'blur' }
                    ],
                    authenticationSecret: [
                        { validator: validateAuthenticationSecret, trigger: 'blur' }
                    ],
                    randomCode: [
                        { validator: validateRandomCode, trigger: 'blur' }
                    ]
                },
                randomCodeRules: [                          // Google随机码规则
                    v => !!v || '',
                    v => (v && v.length == 6) || '',
                    v => /^\d{6}$/.test(v) || ''
                ],
                i18nList: [],
                timeZoneList: [],
                receiveAuthenticationEmail: true,           // 接受返回邮件的选择
                userRight: {},                              // 用户权限对象
                userRightCheck: {},                         // 用户权限对象,用于更新属性时校验是否更改
                userRightVaild: true,                       // 更新用户权限的保存按钮校验
                telegramUser: {},                           // telegram用户对象
                telegramUserUrl: "https://telegram.me/",
            }
        },
        computed: {
            ...mapGetters(["user"])
        },
        created(){
            this.authenticationSuccess();
            this.getUserDetail();
            // this.getI18nList();
            this.getTimeZoneList();
        },
        mounted(){
            //初始化裁剪框,一定要初始化
            this.initCropper();
            //回车提交验证码
            $(document).on('keypress','#enter-verify-code', (event) => {
                if (event.keyCode == 13) {
                    this.verityRandomCode('formDisableAuthentication');
                }
            });
        },
        watch:{
            '$route': 'authenticationSuccess',
            userRight: {
                handler(){
                    let flag = isObjectValueEqual(this.userRight, this.userRightCheck);
                    if (flag) {
                        this.userRightVaild = true;
                    } else {
                        this.userRightVaild = false;
                    }
                },
                deep:true
            }
        },
        methods: {
            //切换菜单
            getMenuData(name){
                switch (name) {
                    case "account":
                        this.isShowAccount = true;
                        this.isShowPassword = false;
                        this.isShowKyc = false;
                        this.isShowPrivacyAndSafety = false;
                        this.isShowGoogleAuthentication = false;
                        this.isShowAccountBinding = false;
                        break;
                    case "password":
                        this.isShowAccount = false;
                        this.isShowPassword = true;
                        this.isShowKyc = false;
                        this.isShowPrivacyAndSafety = false;
                        this.isShowGoogleAuthentication = false;
                        this.isShowAccountBinding = false;
                        break;
                    case "kyc":
                        this.isShowAccount = false;
                        this.isShowPassword = false;
                        this.isShowKyc = true;
                        this.isShowPrivacyAndSafety = false;
                        this.isShowGoogleAuthentication = false;
                        this.isShowAccountBinding = false;
                        break;
                    case "privacyAndSafety":
                        this.isShowAccount = false;
                        this.isShowPassword = false;
                        this.isShowKyc = false;
                        this.isShowPrivacyAndSafety = true;
                        this.isShowGoogleAuthentication = false;
                        this.isShowAccountBinding = false;
                        break;
                    case "googleAuthentication":
                        this.isShowAccount = false;
                        this.isShowPassword = false;
                        this.isShowKyc = false;
                        this.isShowPrivacyAndSafety = false;
                        this.isShowGoogleAuthentication = true;
                        this.isShowAccountBinding = false;
                        break;
                    case "accountBinding":
                        this.getTelegramUserByUserId();
                        this.isShowAccount = false;
                        this.isShowPassword = false;
                        this.isShowKyc = false;
                        this.isShowPrivacyAndSafety = false;
                        this.isShowGoogleAuthentication = false;
                        this.isShowAccountBinding = true;
                        break;
                    default:
                        break;
                }
            },
            //获得用户详情信息
            getUserDetail(){
                this.$http.get(config.baseUrl + "userDetail/getMe").then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.userDetail = data.result;
                        document.title = this.userDetail.nickName + "(@" + this.userDetail.userName + ")——SiP";
                        // 查找等级
                        // this.getLevelById();
                    }else{
                        this.$router.push({name: 'page404'});
                    }
                });
                this.$http.get(config.baseUrl + "userRight/getUserRight?userId=" + this.$store.state.user.id).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        this.userRight = data.result;
                        this.userRightCheck = Object.assign({}, data.result);
                    }
                });
            },
            //根据等级id查找等级
            getLevelById(){
                this.$http.get(config.baseUrl + 'level/getLevel/' + this.userDetail.levelId).then((successData) => {
                    let data = successData.data;
                    this.level = data.result;
                });
            },
            // 查询i18n集合
            getI18nList(){
                let url = config.baseUrl + 'i18n/getI18nAllList';
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.i18nList = data.result;
                    } else {
                        this.i18nList = [];
                    }
                });
            },
            // 查询时区集合
            getTimeZoneList(){
                let url = config.baseUrl + 'timeZone/getTimeZoneList';
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.timeZoneList = data.result;
                    } else {
                        this.timeZoneList = [];
                    }
                });
            },
            //初始化裁剪框,一定要初始化
            initCropper(){
                var self = this;
                var image = document.getElementById('image');
                this.cropper = new Cropper(image, {aspectRatio: 1, viewMode: 1, background:false, zoomable:false,
                    ready: function(){
                        self.croppable = true;
                    }
                });
            },
            //上传之前调用的函数
            beforeUpload(files){
                this.panel = true;
                this.picValue = files;
                //每次替换图片要重新得到新的url
                this.panelImageUrl = this.getObjectURL(this.picValue);
                if(this.cropper){
                    this.cropper.replace(this.panelImageUrl);
                }
                //return false表示不自动上传
                return false;
            },
            //获得文件的url
            getObjectURL (file) {
                var url = null;
                if (window.createObjectURL!=undefined) { // basic
                    url = window.createObjectURL(file);
                } else if (window.URL!=undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                } else if (window.webkitURL!=undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                }
                return url;
            },
            getRoundedCanvas (sourceCanvas) {
                var canvas = document.createElement('canvas');
                var context = canvas.getContext('2d');
                var width = sourceCanvas.width;
                var height = sourceCanvas.height;
                canvas.width = width;
                canvas.height = height;
                context.imageSmoothingEnabled = true;
                context.drawImage(sourceCanvas, 0, 0, width, height);
                context.globalCompositeOperation = 'destination-in';
                context.beginPath();
                context.arc(width / 2, height / 2, Math.min(width, height) / 2, 0, 2 * Math.PI, true);
                context.fill();
                return canvas;
            },
            //关闭面板
            cancelPanel(){
                this.panel = false;
            },
            //截取图片
            cropperImage(){
                this.panel = false;
                var croppedCanvas;
                var roundedCanvas;
                if (!this.croppable) {
                    return;
                }
                croppedCanvas = this.cropper.getCroppedCanvas();
                roundedCanvas = this.getRoundedCanvas(croppedCanvas);
                this.headerImage = roundedCanvas.toDataURL();
                this.uploadAvatar();
            },
            //上传截取后的base64头像
            uploadAvatar(){
                const loading = this.$Message.loading({
                    content: this.$t("userSetting.uploading"),
                    duration: 0
                });
                var fileData = new FormData();
                var that = this;
                var url = config.baseUrl + "userDetail/uploadAvatar/file/" + this.$store.state.user.id;
                // 压缩头像为150*150大小的图片
                canvasDataURL(that.headerImage, { width: 150, height: 150 }, function(base64Codes){
                    var blob = convertBase64UrlToBlob(base64Codes);
                    //upfile是键，file是值，就是要传的文件
                    fileData.append('upfile', blob, Date.parse(new Date())+".png");
                    that.$http.post(url, fileData).then(successData => {
                        let data = successData.data;
                        setTimeout(loading, 500);
                        if (data.resCode == 0) {
                            that.userDetail.image = data.result;
                            that.$store.dispatch('imageHandler', data.result);
                            that.$store.state.user.image = data.result;
                            localStorage.setItem("image", data.result);
                        }else{
                            that.$Message.error(that.$t("common.fail"));
                        }
                    }, error => {
                        setTimeout(loading, 500);
                        that.$Message.error(that.$t("common.fail"));
                    });
                });

                // let url = config.baseUrl + "userDetail/uploadAvatar/base64/" + this.$store.state.user.id;
                // this.$http.post(url, this.headerImage).then(successData => {
                //     let data = successData.data;
                //     setTimeout(loading, 10);
                //     if (data.resCode == 0) {
                //         this.userDetail.image = data.result;
                //         this.$store.state.user.image = data.result;
                //         localStorage.setItem("image", data.result);
                //     }else{
                //         this.$Message.error(this.$t("common.fail"));
                //     }
                // }, error => {
                //     setTimeout(loading, 10);
                //     this.$Message.error(this.$t("common.fail"));
                // });
            },
            //头像上传成功后的回调函数
            uploadSuccess(response, file, fileList){
                this.userDetail.image = response.result;
                this.$store.state.user.image = response.result;
                localStorage.setItem("image", response.result);
            },
            //头像上传过程的加载中消息
            uploadProgress(event, file, fileList){
                this.$Message.loading(this.$t("common.loading"));
            },
            //封面上传之前压缩图片
            uploadCoverImageBefore(file){
                const loading = this.$Message.loading({
                    content: this.$t("userSetting.uploading"),
                    duration: 0
                });
                var fileData = new FormData();
                var url = config.baseUrl + 'userDetail/uploadCoverImage?userId=' + this.$store.state.user.id;
                var that = this;
                photoCompress(file, { quality: 0.2 }, function(base64Codes){
                    var blob = convertBase64UrlToBlob(base64Codes);
                    //upfile是键，file是值，就是要传的文件
                    fileData.append('coverImage', blob, file.name);
                    that.$http.post(url, fileData).then(response => {
                        let data = response.data;
                        if (data.resCode == 0) {
                            that.userDetail.coverImage = data.result;
                        }
                        setTimeout(loading, 500);
                    }, error => {
                        setTimeout(loading, 0);
                        that.$Message.error(that.$t("common.fail"));
                    });
                });
                return false;
            },
            //封面上传过程的加载中消息
            uploadCoverImageProgress(event, file, fileList){
                this.$Message.loading(this.$t("common.loading"));
            },
            //封面图片上传成功的函数
            uploadCoverImageSuccess(response, file, fileList){
                this.userDetail.coverImage = response.result;
            },
            //失败提示
            uploadError(){
                this.$Message.error(this.$t("common.fail"));
            },
            //是否显示昵称的修改输入框
            showNickNameInput(){
                this.userDetail.nickName = this.user.nickName;
                this.isShowNickName = !this.isShowNickName;
                this.isShowNickNameInput = !this.isShowNickNameInput;
            },
            //修改昵称
            updateNickName(){
                this.formNickName.nickName = this.userDetail.nickName;
                this.isShowNickName = !this.isShowNickName;
                this.isShowNickNameInput = !this.isShowNickNameInput;
                this.$http.post(config.baseUrl + "user/updateNickName", this.formNickName).then((successData) => {
                    let data = successData.data;
                    if(data.resCode == 0){
                        this.userDetail.nickName = data.result;
                    }
                },(errorData) => {
                    this.$Message.error(this.$t("common.serverError"));
                });
            },
            //是否显示更换邮箱的输入框
            showRegEmailInput(){
                this.userDetail.regEmail = this.user.regEmail;
                this.isShowRegEmailInput = !this.isShowRegEmailInput;
            },
            //发送更新邮箱的验证邮件
            sendUpdateRegEmail(){
                this.formRegEmail.id = this.userDetail.userId;
                this.formRegEmail.regEmail = this.userDetail.regEmail;
                let validationEmailUrl = config.baseUrl + "user/open/register/validationEmail";    //验证邮箱是否存在
                this.$http.post(validationEmailUrl, this.formRegEmail).then((successData) => {
                    let data = successData.data;
                    if (data.resCode == 0) {
                        let sendEmailUrl = config.baseUrl + 'user/sendUpdateRegEmail';
                        this.isShowRegEmailInput = !this.isShowRegEmailInput;
                        this.$http.post(sendEmailUrl, this.formRegEmail).then((successData) => {
                            let data = successData.data;
                            if (data.resCode == 0) {
                                this.userDetail.regEmail = this.user.regEmail;
                                this.$Notice.success({
                                    title: this.$t("userSetting.notice.updateEmail.title"),
                                    desc: this.$t("userSetting.notice.updateEmail.desc"),
                                    duration: 0
                                });
                            }else if (data.resCode == -10001) {
                                this.isShowRegEmailInput = !this.isShowRegEmailInput;
                                this.$Message.error(this.$t("userSetting.message.emailAnomaly"));
                            }
                        });
                    } else if (data.resCode == 1) {
                        this.isShowRegEmailInput = !this.isShowRegEmailInput;
                        this.$Message.error(this.$t("userSetting.message.registered"));
                    }
                });
            },
            //复制邀请链接
            copyInvitationLink(){
                var clipboard = new Clipboard('#invitationLink');
                clipboard.on('success', e => {
                  this.$Message.success(this.$t("common.copySuccess"));
                  // 释放内存
                  clipboard.destroy();
                })
                clipboard.on('error', e => {
                  // 该浏览器不支持自动复制
                  this.$Message.error(this.$t("common.copyFailure"));
                  // 释放内存
                  clipboard.destroy();
                })
            },
            //分享邀请链接
            shareInvitationLink(){
                //暂未开放
                this.$Message.info("敬请期待分享邀请码!");
            },
            // 更新i18n语言
            updateI18n(i18nId){
                let userInfo = {'userId': this.userDetail.userId, 'i18nId': i18nId};
                let url = config.baseUrl + 'userDetail/updateI18n';
                this.$http.post(url, userInfo).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.$i18n.locale = data.result.code;
                        localStorage.setItem("locale", data.result.code);
                        this.$Message.success(this.$t("common.success"));
                    }
                });
            },
            // 更新时区
            updateTimeZone(){
                let url = config.baseUrl + 'userDetail/updateTimeZone?timeZoneId=' + this.userDetail.timeZoneId + '&userId=' + this.userDetail.userId;
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.$store.dispatch("timeZoneHandler", data.result);
                    }
                });
            },
            //截取头像链接长度
            subImageLink(image){
                if ((image+'').length > 20) {
                    return image.substring(0, 20) + "...";
                }else{
                    return image;
                }
            },
            //是否显示更换头像链接的输入框
            showImageInput(){
                this.userDetail.image = this.user.image;
                this.isShowImageInput = !this.isShowImageInput;
            },
            //修改头像地址
            updateImage(){
                this.formImage.image = this.userDetail.image;
                this.formImage.userId = this.userDetail.userId;
                this.$http.post(config.baseUrl + 'userDetail/updateImage', this.formImage).then((successData) => {
                    let data = successData.data;
                    this.isShowImageInput = !this.isShowImageInput;
                    if (data.resCode == 0) {
                        this.userDetail.image = data.result;
                        this.$store.state.user.image = data.result;
                        localStorage.setItem("image", data.result);
                    }
                });
            },
            //是否显示更换封面链接的输入框
            showCoverImageInput(){
                this.userDetail.coverImage = this.user.coverImage;
                this.isShowCoverImageInput = !this.isShowCoverImageInput;
            },
            //修改封面地址
            updateCoverImage(){
                this.formCoverImage.coverImage = this.userDetail.coverImage;
                this.formCoverImage.userId = this.userDetail.userId;
                this.$http.post(config.baseUrl + 'userDetail/updateCoverImage', this.formCoverImage).then((successData) => {
                    let data = successData.data;
                    this.isShowCoverImageInput = !this.isShowCoverImageInput;
                    if (data.resCode == 0) {
                        this.userDetail.coverImage = data.result;
                    }
                });
            },
            //跳转到密码页面
            goPassword(){
                this.$router.push({name:'password'})
            },
            //修改密码发送请求
            updatePassword() {
                if (this.$refs.formPassword.validate()) {
                    this.formPassword.id = this.userDetail.userId;
                    let passWord = Md5(this.formPassword.passWord);
                    passWord = passWord.split('').reverse().join('');
                    passWord = Md5(passWord);
                    let sha256 = require("js-sha256").sha256;
                    let passWord_v2 = sha256(this.formPassword.passWord);
                    let newPassWord = sha256(this.formPassword.newPassWord);
                    let confirmNewPassWord = sha256(this.formPassword.confirmNewPassWord);
                    const userPasswordFormData = {
                        id: this.formPassword.id,
                        passWord: passWord,
                        passWord_v2: passWord_v2,
                        newPassWord: newPassWord,
                        confirmNewPassWord: confirmNewPassWord
                    };
                    //校验成功后，发送请求
                    let url = config.baseUrl + "user/updatePasswordByPassword";
                    this.$http.post(url, userPasswordFormData).then(function(successData){
                        let data = successData.data;
                        if (data.resCode == 0) {
                            this.$refs.formPassword.reset();
                            this.$Notice.success({
                                title: this.$t("userSetting.notice.updatePassword.title"),
                                desc: this.$t("userSetting.notice.updatePassword.desc"),
                                duration: 0
                            });
                        }else if (data.resCode == -3) {
                            this.$refs.formPassword.reset();
                            this.$Notice.error({
                                title: this.$t("userSetting.errorCallback.confirmNewPassWord.match"),
                                duration: 0
                            });
                        }else if (data.resCode == -5) {
                            this.$refs.formPassword.reset();
                            this.$Notice.error({
                                title: this.$t("userSetting.errorCallback.passWord.error"),
                                duration: 0
                            });
                        }else if (data.resCode == -1) {
                            this.$refs.formPassword.reset();
                            this.$Notice.error({
                                title: this.$t("enableAuthentication.dangerousMsg"),
                                duration: 0
                            });
                        }
                    }, (errorData) => {
                        this.$Message.error(this.$t("common.serverError"));
                        this.$refs.formPassword.reset();
                    });
                }
            },
            //跳转至开启谷歌验证页面
            // gotoAuthentication(){
            //     let url = config.baseUrl + "user/updateAuthentication";
            //     this.formAuthentication.id = this.userDetail.userId;
            //     this.enableLoading = !this.enableLoading;
            //     this.$http.post(url, this.formAuthentication).then((successData) => {
            //         this.enableLoading = !this.enableLoading;
            //         this.$router.push({name:'enableAuthentication'});
            //     },(errorData) => {
            //         this.enableLoading = !this.enableLoading;
            //         this.$Message.error(this.$t("common.serverError"));
            //     });
            // },
            gotoAuthentication(){
                let url = config.baseUrl + "user/openAuthentication";
                this.formAuthentication.id = this.userDetail.userId;
                this.enableLoading = !this.enableLoading;
                this.$http.post(url, this.formAuthentication).then((successData) => {
                    this.enableLoading = !this.enableLoading;
                    this.$router.push({name:'enableAuthentication'});
                },(errorData) => {
                    this.enableLoading = !this.enableLoading;
                    this.$Message.error(this.$t("common.serverError"));
                });
            },
            //认证成功后重新加载userDetail
            authenticationSuccess(){
                if (sessionStorage.getItem('authentication') == true) {
                    this.getUserDetail();
                    sessionStorage.setItem('authentication', false);
                }
            },
            //跳转至重置认证页面
            resetAuthentication(){
                this.$router.push({name:'resetAuthentication',params:{userId: this.userDetail.userId}});
            },
            //显示禁用认证的模态框
            showDisableModal(){
                this.isShowDisableModal = !this.isShowDisableModal;
            },
            //关闭禁用认证的模态框
            disableModalCancel(){
                this.isShowDisableModal = !this.isShowDisableModal;
            },
            //vuetify验证随机码是否正确
            verityRandomCode(name){
                this.formDisableAuthentication.id = this.userDetail.userId;
                this.formDisableAuthentication.authenticationSecret = this.userDetail.authenticationSecret;
                if (this.$refs[name].validate()) {
                    let url = config.baseUrl + "user/updateAuthenticationStatus";
                    this.$http.post(url, this.formDisableAuthentication).then((successData) => {
                        let data = successData.data;
                        this.formDisableAuthentication.randomCode = '';
                        if (data.resCode == 0) {
                            this.$Message.success(this.$t("common.success"));
                            this.isShowDisableModal = !this.isShowDisableModal;
                            this.userDetail.openAuthentication = false;
                        }else if(data.resCode == -1){
                            this.$Message.error(this.$t("enableAuthentication.dangerousMsg"));
                        }else if(data.resCode == -2){
                            this.$Message.error(this.$t("enableAuthentication.verificationCodeError"));
                        }else if(data.resCode == -3){
                            this.$Message.error(this.$t("common.serverError"));
                        }
                    },(errorData) => {
                        this.$Message.error(this.$t("common.serverError"));
                    });
                } else {
                    this.$Message.error(this.$t("common.fail"));
                    this.formDisableAuthentication.randomCode = '';
                }
            },
            //禁用认证请求
            disableAuthentication(name){
                this.formDisableAuthentication.id = this.userDetail.userId;
                this.formDisableAuthentication.authenticationSecret = this.userDetail.authenticationSecret;
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let url = config.baseUrl + "user/updateAuthenticationStatus";
                        this.$http.post(url, this.formDisableAuthentication).then((successData) => {
                            let data = successData.data;
                            this.formDisableAuthentication.randomCode = '';
                            if (data.resCode == 0) {
                                this.$Message.success(this.$t("common.success"));
                                this.isShowDisableModal = !this.isShowDisableModal;
                                this.userDetail.openAuthentication = false;
                            }else if(data.resCode == -1){
                                this.$Message.error(this.$t("enableAuthentication.dangerousMsg"));
                            }else if(data.resCode == -2){
                                this.$Message.error(this.$t("enableAuthentication.verificationCodeError"));
                            }else if(data.resCode == -3){
                                this.$Message.error(this.$t("common.serverError"));
                            }
                        },(errorData) => {
                            this.$Message.error(this.$t("common.serverError"));
                        });
                    }
                });
            },
            //更新SIP Token
            updateSipToken(){
                let url = config.baseUrl + "userDetail/updateSipToken?userId=" + this.userDetail.userId;
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.userDetail.sipToken = data.result;
                        //刷新渲染视图
                        this.$forceUpdate();
                    }
                });
            },
            //复制SIP Token
            copySipToken(){
                var clipboard = new Clipboard('#sipToken');
                clipboard.on('success', e => {
                  this.$Message.success(this.$t("common.copySuccess"));
                  // 释放内存
                  clipboard.destroy();
                })
                clipboard.on('error', e => {
                  // 该浏览器不支持自动复制
                  this.$Message.error(this.$t("common.copyFailure"));
                  // 释放内存
                  clipboard.destroy();
                })
            },
            // 更新用户权限对象
            updateUserRight(){
                let url = config.baseUrl + 'userRight/updateUserRight';
                this.$http.post(url, this.userRight).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.userRight = data.result;
                        this.userRightCheck = Object.assign({}, data.result);
                    }
                });
            },
            // 获得telegram用户对象
            getTelegramUserByUserId(){
                let url = config.baseUrl + "telegramUser/getTelegramUser?userId=" + this.$store.state.user.id;
                this.$http.get(url).then(response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.telegramUser = data.result;
                        this.telegramUserUrl = "https://telegram.me/" + this.telegramUser.userName;
                    } else {
                        this.telegramUserUrl = "https://telegram.me/sip_test_bot";
                    }
                });
            },
            gotoKyc(){
                this.$router.push({name: 'userKyc'});
            },
            //点击其它区域隐藏区块
            hideBlock(event){

            },
            //格式化注册时间
            regTimeFormat(time) {
                return formatTime(time, this.$i18n.locale);
            },
        },

    }
</script>



// WEBPACK FOOTER //
// UserSetting.vue?befefe9c